import ScrollTrigger from 'gsap/ScrollTrigger';
import { gsap } from 'gsap/gsap-core';
import { computePosition, offset, flip, shift } from '@floating-ui/dom';
import { sideBySideCompare } from '../lib/sideBySideCompare';
import { EraseCompare } from '../lib/EraseCompare';

import beforeImage from '../../images/compare/skin-before.jpg?url';

function initTooltip(card) {
  const body = card.querySelector('.compare__card-inner');
  const tooltip = card.querySelector('.compare__tooltip');

  if (!body || !tooltip) return;

  const placement = tooltip.dataset.placement || 'top';

  function update() {
    computePosition(body, tooltip, {
      middleware: [
        offset({ mainAxis: -100, crossAxis: 50 }),
        flip(),
        shift({ padding: 20 }),
      ],
      placement,
    }).then(({ x, y }) => {
      Object.assign(tooltip.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
  }

  function showTooltip() {
    update();

    gsap.fromTo(tooltip, { y: 10, autoAlpha: 0 }, { y: 0, autoAlpha: 1 });
  }

  function hideTooltip() {
    gsap.fromTo(tooltip, { y: 0, autoAlpha: 1 }, { y: -10, autoAlpha: 0 });
  }

  [
    ['mouseenter', showTooltip],
    ['mouseleave', hideTooltip],
    ['focus', showTooltip],
    ['blur', hideTooltip],
  ].forEach(([event, listener]) => {
    body.addEventListener(event, listener);
  });
}

export function initCompare() {
  const parent = document.querySelector('.compare');
  if (!parent) return;

  const sideBySideEl = parent.querySelector('.compare__side-by-side');
  if (sideBySideEl) sideBySideCompare(sideBySideEl);

  const eraseEl = parent.querySelector('.compare__erase');
  if (eraseEl) {
    ScrollTrigger.create({
      trigger: parent,
      start: 'top-=200 bottom',
      once: true,
      onEnter: async () => {
        new EraseCompare(eraseEl, {
          imageUrl: beforeImage,
          eraserSize: 90,
          cursorClass: 'compare__cursor',
        });
      },
    });
  }

  const cards = [...parent.querySelectorAll('.compare__card')];
  cards.forEach((card) => {
    initTooltip(card, parent);

    const inner = card.querySelector('.compare__card-inner');
    gsap.fromTo(
      inner,
      { autoAlpha: 0, scale: 0.9, y: 10 },
      {
        autoAlpha: 1,
        scale: 1,
        y: 0,
        scrollTrigger: { trigger: card, start: 'top bottom-=200' },
      },
    );
  });

  // parallax
  gsap.matchMedia().add('(min-width: 1024px)', async () => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: parent,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
        // markers: true,
      },
      defaults: { ease: 'none' },
    });
    tl.fromTo(
      '.compare__card--is-next-gen',
      { y: 70, skewX: -2 },
      { y: -50, skewX: 2 },
    );
    tl.fromTo(
      '.compare__card--is-every-skin',
      { y: 100, skewX: -2 },
      { y: -70, skewX: 2 },
      '<',
    );
    tl.fromTo(
      '.compare__card--is-impact',
      { y: 110, skewX: -2 },
      { y: -70, skewX: 2 },
      '<',
    );
    tl.fromTo(
      '.compare__card--is-penetration',
      { y: 170, skewX: -2 },
      { y: -200, skewX: 2 },
      '<',
    );
  });
}
